import Logger from 'core/utils/Logger'

import type { IAttentionStatusOfferingMaskApi } from '../api/types'
import type { IAttentionOfferingMask } from '../model/types'

const isOfferingMask = (entry: IAttentionStatusOfferingMaskApi): boolean =>
  typeof entry?.Offering === 'string' && typeof entry?.Status === 'number'

/**
 * A partner's `CockpitAttentionStatus` as masks per offering.
 *
 * The field is a JSON-encoded list of `{ Offering, Status }` — one mask per offering the partner
 * plans for. Malformed JSON is logged and read as no masks, so a broken field hides the tile
 * rather than breaking the cockpit.
 */
export const parseAttentionStatusMasks = (
  raw: string | null | undefined
): IAttentionOfferingMask[] => {
  if (!raw) {
    return []
  }

  try {
    const parsed = JSON.parse(raw) as IAttentionStatusOfferingMaskApi[]

    if (!Array.isArray(parsed)) {
      return []
    }

    return parsed
      .filter(isOfferingMask)
      .map(({ Offering, Status }) => ({ offering: Offering, mask: Status }))
  } catch (e) {
    Logger.error(`CockpitAttentionStatus: ${e}`)
    return []
  }
}
